import mainConfig from '@proccess/config/main-config';
import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import {
  TypedUseSelectorHook,
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { actions } from './reducer';
import rootSaga from './saga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: persistReducer(mainConfig.reduxPersist, rootReducer),
  middleware: [sagaMiddleware],
  devTools: true,
});

sagaMiddleware.run(rootSaga);

const stores = () => {
  return store;
};

const { dispatch, getState } = store;
const persistor = persistStore(store);

export type ReduxStore = ReturnType<typeof stores>;
export type AppState = ReturnType<typeof getState>;
export type AppDispatch = typeof store.dispatch;

const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;
const useDispatch = () => useAppDispatch<any>();

const wrapper = createWrapper<ReduxStore>(stores);
const useStore = wrapper.useWrappedStore;
const useGetState = () => useSelector((state) => state);

export {
  dispatch,
  persistor,
  stores,
  useDispatch,
  useSelector,
  useGetState,
  useStore,
  wrapper,
  actions,
};
